<template lang="pug">
  div.verticalGeneric.map-panel
    div.maxSizeMain
      ods-row(type="flex" justify="start").sc-panel__header
        //- ods-col(:span="7")
        //-   InfoMsg(:alerts='selectedItems')
        ods-col(v-if="verticalType !== 'CRM'")
          carousel(
            v-if='carouselButtons'
            :perPageCustom='[[480, 1], [768, 1]]'
            :paginationEnabled='false'
            :navigationEnabled='true'
            :centerMode='true'
            navigationNextLabel='<em class="ods-icon-arrow-right"></em>'
            navigationPrevLabel='<em class="ods-icon-arrow-left"></em>'
          )
            //- slide
            //-   ods-button(size="small" type="secondary" v-if="$route.name=='AutobusesDashboard'") {{ $t('historic') }}
            slide
              ods-button(size="small" type="secondary" @click.prevent="showDialogAlert()") {{ $t('alerts') }}
            slide
              ods-button(size="small" type="secondary" @click.prevent="showDialogCampaign()") {{ $t('campaigns') }}
          div(v-else ref='buttons')
            //- ods-button(size="small" type="secondary" v-if="$route.name=='AutobusesDashboard'") {{ $t('historic') }}
            ods-button(size="small" type="secondary" @click.prevent="showDialogAlert()") {{ $t('alerts') }}
            ods-button(size="small" type="secondary" @click.prevent="showDialogCampaign()") {{ $t('campaigns') }}
      ods-row.sc-dashboard__row(type="flex")
        ods-col.sc-dashboard__col(:span='24')
          Card(:scrollbar="false" :loading='loadingKpis').sc-dashboard__kpis
            template(slot="header")
              div.card-title
                div.custom-icon
                  i(:class='iconSelected')
                span.titleStation  {{ $t(titleStation) }} {{ typeVehicule }}
              ods-select(
                v-model='kpisCurrentFilter'
                placeholder='Select'
                @change="filterIntervalKpisChange"
                v-if='!chartHide'
                size="deci"
              )
                ods-option(
                  v-for='(item, index) in kpisFilters'
                  :key='index'
                  :label='$t(item.label)'
                  :value='item.value'
                  size="small"
                )
            ods-tabs.tabs(v-model="tabs" @tab-click="handleClick" v-if="verticalType === 'CRM'")
              ods-tab-pane(v-for="item in verticalTabs" :label="$t(item.label)" :key="item.value" :value="item.value" :name="item.value")
                div.sc-dashboard__kpis__content(v-if='item.value !== "alertas"')
                  template(v-if='kpiAlert && kpisStation && !kpisStation.length')
                    div.maxSizeKpiAlert
                      KpiVertical(typeData='alerta' ref="kpiVertical" :dataKpis='kpiAlertContent')
                  div.verticalGeneric__wrapper-all(v-else)
                    ods-scrollbar(wrap-class='ods-scrollbar__wrap')
                      div.maxSizeKpi
                        KpiVertical(ref="kpiVertical"
                        :dataKpis='kpisStation'
                        :tagType='kpiTagType'
                        :interval='kpisCurrentFilter'
                        :iconSelected='iconSelected'
                        :titleKpiSelected='titleKpiSelected'
                        @showChartBykpi='showChartBykpi')
                  template(v-if='!kpiAlert && kpisStation && !kpisStation.length && (!kpisStation.values || kpisStation.length === 0)')
                    template(v-if='onlyParkingPanel')
                      StatusCero(
                        v-if='!loadingKpis'
                        title='no data'
                        description='no data kpi parkingPanel')
                    template(v-else)
                      StatusCero(
                        v-if='!loadingKpis'
                        title='no data'
                        description='no data kpi')
                div(v-else)
                  AlertsAndCampaignListCrm.alertsTab__Crm(
                    wrap-class='ods-scrollbar__wrap'
                    alert
                    link
                    :dataTable='dataTable'
                    typeData='alerta' ref="kpiVertical")
            div.sc-dashboard__kpis__content(v-else)
              template(v-if='!kpiAlert && kpisStation && !kpisStation.length && (!kpisStation.values || kpisStation.length === 0)')
                template(v-if='onlyParkingPanel')
                  StatusCero(
                    v-if='!loadingKpis'
                    title='no data'
                    description='no data kpi parkingPanel'
                  )
                template(v-else)
                  StatusCero(
                    v-if='!loadingKpis'
                    title='no data'
                    description='no data kpi'
                  )
              template(v-if='kpiAlert && kpisStation && !kpisStation.length')
                div.maxSizeKpiAlert
                  KpiVertical(typeData='alerta' ref="kpiVertical" :dataKpis='kpiAlertContent')
              div.verticalGeneric__wrapper-all(v-else)
                ods-scrollbar(wrap-class='ods-scrollbar__wrap')
                  div.maxSizeKpi
                    KpiVertical(ref="kpiVertical"
                    :dataKpis='kpisStation'
                    :tagType='kpiTagType'
                    :interval='kpisCurrentFilter'
                    :iconSelected='iconSelected'
                    :titleKpiSelected='titleKpiSelected'
                    @showChartBykpi='showChartBykpi')
    ModalGeneric(ref="modalGenericAlerts" modalTitle='alerts' modalType='withTab' modalTypeData='alerts')
    ModalGeneric(ref="modalGenericCampaigns" modalTitle='campaigns' modalType='withTab' modalTypeData='campaigns')
    ChartModal(:loading='datosLoader' :title='titleChartModal' :unit='unitChartModal' :data='datosChart')
</template>

<script>
import Card from '@/components/Card'
import InfoMsg from '@/components/InfoMsg'
import StatusCero from '@/components/StatusCero'
import mapElements from '@/mixins/mapElements'
import mapChartsElements from '@/mixins/mapChartsElements'
import AlertsAndCampaignList from '@/components/AlertsAndCampaignList'
import AlertsAndCampaignListCrm from '@/components/AlertsAndCampaignListCrm'
import ModalGeneric from '@/components/ModalGeneric'
import KpiVertical from '@/components/KpiVertical'
import ChartModal from '@/components/ChartModal'
// ENVIRONMENT
import jsonKpisWatherSevenDays from '@/moks/las_palmas/environment/kpisWatherSevenDays'
import jsonKpisWatherToday from '@/moks/las_palmas/environment/kpisWatherToday'
import jsonKpisAirQualitySevenDays from '@/moks/las_palmas/environment/kpisAirQualitySevenDays'
import jsonKpisAirQualityToday from '@/moks/las_palmas/environment/kpisAirQualityToday'
import jsonKpisAlergenosSevenDays from '@/moks/las_palmas/environment/kpisAlergenosSevenDays'
import jsonKpisAlergenosToday from '@/moks/las_palmas/environment/kpisAlergenosToday'
import jsonKpisNoiseLevelSevenDays from '@/moks/las_palmas/environment/kpisNoiseLevelSevenDays'
import jsonKpisNoiseLevelToday from '@/moks/las_palmas/environment/kpisNoiseLevelToday'
import jsonKpisParkingToday from '@/moks/las_palmas/mobility/kpisParkingToday'
import jsonKpisParkingSevenDays from '@/moks/las_palmas/mobility/kpisParkingSevenDays'
import jsonKpisPanelParkingToday from '@/moks/las_palmas/mobility/kpisPanelParkingToday'
import jsonKpisPanelParkingSevenDays from '@/moks/las_palmas/mobility/kpisPanelParkingSevenDays'
import jsonKpisSensorZonesToday from '@/moks/las_palmas/mobility/kpisSensorZonesToday'
import jsonKpisSensorZonesSevenDays from '@/moks/las_palmas/mobility/kpisSensorZonesSevenDays'
import jsonKpisBusToday from '@/moks/las_palmas/mobility/kpisBusToday'
import jsonKpisBusSevenDays from '@/moks/las_palmas/mobility/kpisBusSevenDays'
import jsonKpisBusLineToday from '@/moks/las_palmas/mobility/kpisBusLineToday'
import jsonKpisBusLineSevenDays from '@/moks/las_palmas/mobility/kpisBusLineSevenDays'
import jsonKpisBusStopToday from '@/moks/las_palmas/mobility/kpisBusStopToday'
import jsonKpisBusStopSevenDays from '@/moks/las_palmas/mobility/kpisBusStopSevenDays'
import jsonKpisBikesToday from '@/moks/las_palmas/mobility/kpisBikesToday'
import jsonKpisBikesSevenDays from '@/moks/las_palmas/mobility/kpisBikesSevenDays'
// PARKS AND GARDENS
import jsonKpisParksInformationSevenDays from '@/moks/las_palmas/parksandgardens/kpisParksInformationSevenDays'
import jsonKpisParksInformationToday from '@/moks/las_palmas/parksandgardens/kpisParksInformationToday'
import jsonKpisGroundSevenDays from '@/moks/las_palmas/parksandgardens/kpisGroundSevenDays'
import jsonKpisGroundToday from '@/moks/las_palmas/parksandgardens/kpisGroundToday'
import jsonKpisCountersSevenDays from '@/moks/las_palmas/parksandgardens/kpisCountersSevenDays'
import jsonKpisCountersToday from '@/moks/las_palmas/parksandgardens/kpisCountersToday'
import jsonKpisIncidenceSevenDays from '@/moks/las_palmas/parksandgardens/kpisIncidenceSevenDays'
import jsonKpisIncidenceToday from '@/moks/las_palmas/parksandgardens/kpisIncidenceToday'
import jsonKpisValvesSevenDays from '@/moks/las_palmas/parksandgardens/kpisValvesSevenDays'
import jsonKpisValvesToday from '@/moks/las_palmas/parksandgardens/kpisValvesToday'
// FLEET
import jsonKpisCruisesToday from '@/moks/las_palmas/cruises/kpisCruisesToday'
import jsonKpisCruisesSevenDays from '@/moks/las_palmas/cruises/kpisCruisesSevenDays'
// CRM
import jsonKpisCitizenToday from '@/moks/las_palmas/crm/kpisCitizenToday'
import jsonKpisCitizenSevenDays from '@/moks/las_palmas/crm/kpisCitizenSevenDays'
import jsonKpisSolicitationsToday from '@/moks/las_palmas/crm/kpisSolicitationToday'
import jsonKpisSolicitationsSevenDays from '@/moks/las_palmas/crm/kpisSolicitationSevenDays'
import jsonKpisConsultationsToday from '@/moks/las_palmas/crm/kpisConsultationsToday'
import jsonKpisConsultationsSevenDays from '@/moks/las_palmas/crm/kpisConsultationsSevenDays'
import jsonKpisComplaintsToday from '@/moks/las_palmas/crm/kpisComplaintsToday'
import jsonKpisComplaintsSevenDays from '@/moks/las_palmas/crm/kpisComplaintsSevenDays'
import jsonKpisDamageToday from '@/moks/las_palmas/crm/kpisDamageToday'
import jsonKpisDamageSevenDays from '@/moks/las_palmas/crm/kpisDamageSevenDays'
// CHART JS
import jsonWeatherChartDataToday from '@/moks/las_palmas/environment/weatherChartDataToday'
import jsonWeatherChartDataSevenDays from '@/moks/las_palmas/environment/weatherChartDataSevenDays'
import jsonAirQualityChartDataToday from '@/moks/las_palmas/environment/airQualityChartDataToday'
import jsonAirQualityChartDataSevenDays from '@/moks/las_palmas/environment/airQualityChartDataSevenDays'
import jsonAlergenosChartDataToday from '@/moks/las_palmas/environment/alergenosChartDataToday'
import jsonAlergenosChartDataSevenDays from '@/moks/las_palmas/environment/alergenosChartDataSevenDays'
import jsonNoiseLevelChartDataToday from '@/moks/las_palmas/environment/noiseLevelChartDataToday'
import jsonNoiseLevelChartDataSevenDays from '@/moks/las_palmas/environment/noiseLevelChartDataSevenDays'
import jsonParkingChartDataToday from '@/moks/las_palmas/mobility/parkingChartDataToday'
import jsonParkingChartDataSevenDays from '@/moks/las_palmas/mobility/parkingChartDataSevenDays'
import jsonPanelParkingChartDataToday from '@/moks/las_palmas/mobility/panelParkingChartDataToday'
import jsonPanelParkingChartDataSevenDays from '@/moks/las_palmas/mobility/panelParkingChartDataSevenDays'
import jsonSensorZonesChartDataToday from '@/moks/las_palmas/mobility/sensorZonesChartDataToday'
import jsonSensorZonesChartDataSevenDays from '@/moks/las_palmas/mobility/sensorZonesChartDataSevenDays'
import jsonBusChartDataToday from '@/moks/las_palmas/mobility/busChartDataToday'
import jsonBusChartDataSevenDays from '@/moks/las_palmas/mobility/busChartDataSevenDays'
import jsonBusLineChartDataToday from '@/moks/las_palmas/mobility/busLineChartDataToday'
import jsonBusLineChartDataSevenDays from '@/moks/las_palmas/mobility/busLineChartDataSevenDays'
import jsonBusStopChartDataToday from '@/moks/las_palmas/mobility/busStopChartDataToday'
import jsonBusStopChartDataSevenDays from '@/moks/las_palmas/mobility/busStopChartDataSevenDays'
import jsonBikesChartDataToday from '@/moks/las_palmas/mobility/bikesChartDataToday'
import jsonBikesChartDataSevenDays from '@/moks/las_palmas/mobility/bikesChartDataSevenDays'
import jsonChartParksInformationToday from '@/moks/las_palmas/parksandgardens/chartParksInformationToday'
import jsonChartParksInformationSevenDays from '@/moks/las_palmas/parksandgardens/chartParksInformationSevenDays'
import jsonChartInicidenceToday from '@/moks/las_palmas/parksandgardens/chartIncidenceToday'
import jsonChartInicidenceSevenDays from '@/moks/las_palmas/parksandgardens/chartIncidenceSevenDays'
import jsonChartCountersToday from '@/moks/las_palmas/parksandgardens/chartCountersToday'
import jsonChartCountersSevenDays from '@/moks/las_palmas/parksandgardens/chartCountersSevenDays'
import jsonChartValvesToday from '@/moks/las_palmas/parksandgardens/chartValvesToday'
import jsonChartValvesSevenDays from '@/moks/las_palmas/parksandgardens/chartValvesSevenDays'
import jsonChartGroundToday from '@/moks/las_palmas/parksandgardens/chartGroundToday'
import jsonChartGroundSevenDays from '@/moks/las_palmas/parksandgardens/chartGroundSevenDays'
import jsonChartCruisesToday from '@/moks/las_palmas/cruises/chartCruisesToday'
import jsonChartCruisesSevenDays from '@/moks/las_palmas/cruises/chartCruisesSevenDays'
import jsonChartCitizenToday from '@/moks/las_palmas/crm/chartCitizenToday'
import jsonChartCitizenSevenDays from '@/moks/las_palmas/crm/chartCitizenSevenDays'
import jsonChartSolicitationsToday from '@/moks/las_palmas/crm/chartSolicitationsToday'
import jsonChartSolicitationsSevenDays from '@/moks/las_palmas/crm/chartSolicitationsSevenDays'
import jsonChartComplaintsToday from '@/moks/las_palmas/crm/chartComplaintsToday'
import jsonChartComplaintsSevenDays from '@/moks/las_palmas/crm/chartComplaintsSevenDays'
import jsonChartConsultationsToday from '@/moks/las_palmas/crm/chartConsultationsToday'
import jsonChartConsultationsSevenDays from '@/moks/las_palmas/crm/chartConsultationsSevenDays'
import jsonChartDamageToday from '@/moks/las_palmas/crm/chartDamageToday'
import jsonChartDamageSevenDays from '@/moks/las_palmas/crm/chartDamageSevenDays'
// ALERTS AND CAMAPAINGS
import jsonAlertsMeteorologia from '@/moks/las_palmas/environment/alertsMeteorologia'
import jsonCampaingsMeteorologia from '@/moks/las_palmas/environment/campaingsEnvironment'
import jsonAlertsMobility from '@/moks/las_palmas/mobility/alertsMobility'
import jsonCampaingsMobility from '@/moks/las_palmas/mobility/campaingsMobility'
import jsonAlertsParksandgardens from '@/moks/las_palmas/parksandgardens/alertsParksandgardens'
import jsonCampaingsParksandgardens from '@/moks/las_palmas/parksandgardens/campaingsParksandgardens'
import jsonAlertsCruises from '@/moks/las_palmas/cruises/alertsCruises'
import jsonCampaingsCruises from '@/moks/las_palmas/cruises/campaingsCruises'
import jsonAlertsCRM from '@/moks/las_palmas/crm/alertsCRM'
// TEST
import * as _ from 'lodash'

let stationSelected = null

export default {
  name: 'VerticalGeneric',
  data () {
    return {
      kpisFilters: [
        {
          value: '1d',
          label: 'last day'
        }, {
          value: '7d',
          label: 'last seven days'
        }
      ],
      listTypes: [],
      kpisCurrentFilter: '1d',
      kpiSelected: null,
      titleKpiSelected: null,
      chartsData: null,
      zoomChartKpiData: null,
      chartModal: false,
      kpisStation: [],
      titleStation: 'city',
      selectedItems: 0,
      kpiAlert: false,
      kpiAlertContent: [],
      chartHide: false,
      iconSelected: '',
      unitChart: '',
      datosLoader: false,
      titleChartModal: null,
      unitChartModal: null,
      datosChart: null,
      windowWidth: 0,
      carouselButtons: false,
      buttonsLength: '',
      onlyParkingPanel: false,
      kpiTagType: '',
      loadingKpis: true,
      typeVehicule: '',
      currentKpi: null,
      verticalTabs: [{
        value: 'tramites',
        label: 'Transactions'
      },
      {
        value: 'ciudadanos',
        label: 'Citizens'
      },
      {
        value: 'alertas',
        label: 'Alert'
      }],
      tabs: 'tramites',
      dataTable: undefined,
      dataTableAux: undefined,
      dataTableWeek: undefined,
      dataTableToday: undefined,
      categorySelect: undefined
    }
  },
  props: {
    verticalType: {
      type: String
    }
  },
  mixins: [ mapElements, mapChartsElements ],
  methods: {
    updateKpisCRM (category) {
      const component = this
      this.kpisStation = []
      let kpisStationAux = []
      if (!this.categorySelect) {
        this.categorySelect = category
      } else {
        if (!category) {
          category = this.categorySelect
        } else {
          this.categorySelect = category
        }
      }
      this.loadingKpis = true
      if (this.tabs === 'tramites') {
        setTimeout(() => {
          switch (category) {
            case 'dataSourceAll':
              this.getJsonKpisCitizenToday()
              this.getJsonKpisCitizenSevenDays()
              this.getJsonKpisSolicitationsToday()
              this.getJsonKpisSolicitationsSevenDays()
              this.getJsonKpisSolicitationsToday()
              this.getJsonKpisSolicitationsSevenDays()
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisCitizenToday] : [...kpisStationAux, ...jsonKpisCitizenSevenDays]
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisSolicitationsToday] : [...kpisStationAux, ...jsonKpisSolicitationsSevenDays]
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisComplaintsToday] : [...kpisStationAux, ...jsonKpisComplaintsSevenDays]
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisDamageToday] : [...kpisStationAux, ...jsonKpisDamageSevenDays]
              break
            case 'dataSourceConsultations':
              this.getJsonKpisConsultationsToday()
              this.getJsonKpisConsultationsSevenDays()
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisConsultationsToday] : [...kpisStationAux, ...jsonKpisConsultationsToday]
              break
            case 'dataSourceSolicitations':
              this.getJsonKpisSolicitationsToday()
              this.getJsonKpisSolicitationsSevenDays()
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisSolicitationsToday] : [...kpisStationAux, ...jsonKpisSolicitationsSevenDays]
              break
            case 'dataSourceComplaints':
              this.getJsonKpisComplaintsToday()
              this.getJsonKpisComplaintsSevenDays()
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisComplaintsToday] : [...kpisStationAux, ...jsonKpisComplaintsSevenDays]
              break
            case 'dataSourceDamage':
              this.getJsonKpisDamageToday()
              this.getJsonKpisDamageSevenDays()
              kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisDamageToday] : [...kpisStationAux, ...jsonKpisDamageSevenDays]
              break
          }
          component.kpisStation = kpisStationAux
          for (let i = 0; i < component.kpisStation.length; i++) {
            component.kpisStation[i].show = true
          }
        }, 1000)
      } else if (this.tabs === 'ciudadanos') {
        this.getJsonKpisCitizenToday()
        this.getJsonKpisCitizenSevenDays()
        kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisCitizenToday] : [...kpisStationAux, ...jsonKpisCitizenSevenDays]
        component.kpisStation = kpisStationAux
        for (let i = 0; i < component.kpisStation.length; i++) {
          component.kpisStation[i].show = true
        }
      }
      this.loadingKpis = false
    },
    getJsonKpisCitizenToday () {
      jsonKpisCitizenToday.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisCitizenSevenDays () {
      jsonKpisCitizenSevenDays.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisSolicitationsToday () {
      jsonKpisSolicitationsToday.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisSolicitationsSevenDays () {
      jsonKpisSolicitationsSevenDays.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisConsultationsToday () {
      jsonKpisConsultationsToday.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisConsultationsSevenDays () {
      jsonKpisConsultationsSevenDays.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisComplaintsToday () {
      jsonKpisComplaintsToday.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisComplaintsSevenDays () {
      jsonKpisComplaintsSevenDays.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisDamageToday () {
      jsonKpisDamageToday.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    getJsonKpisDamageSevenDays () {
      jsonKpisDamageSevenDays.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = this.setTimeRandom(false)
      })
    },
    updateCitizen () {
      const component = this
      var kpisStationAux = []
      this.loadingKpis = true
      this.kpisStation = []
      setTimeout(() => {
        this.getJsonKpisCitizenToday()
        this.getJsonKpisCitizenSevenDays()
        kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisCitizenToday] : [...kpisStationAux, ...jsonKpisCitizenSevenDays]
        component.kpisStation = kpisStationAux
        for (let i = 0; i < component.kpisStation.length; i++) {
          component.kpisStation[i].show = true
        }
        this.loadingKpis = false
      }, 500)
    },
    updateAlertsVertical () {
      let currentFilter = this.kpisCurrentFilter
      this.loadingKpis = true
      // console.log(this.kpisFilters);
      if (this.tabs === 'alertas') {
        this.dataTable = []
        switch (currentFilter) {
          case '7d': {
            this.dataTable = this.dataTableWeek
            break
          }
          case '1d': {
            this.dataTable = this.dataTableToday
            break
          }
          default: {
            this.dataTable = this.dataTableWeek
            break
          }
        }
        this.loadingKpis = false
        // console.log('tap---->', this.tabs, 'kpisCurrentFilter---->', this.kpisCurrentFilter);
      }
    },
    handleClick (tab, event) {
      // console.log('tab y eventoooooo---_>', tab, event);

      // console.log(event.target.id);
      // const component = this
      this.kpisStation = []
      switch (event.target.id) {
        case 'tab-tramites':
          this.categoryPush = undefined
          this.$emit('filterAc', true)
          this.updateKpisCRM(this.categorySelect)
          break
        case 'tab-ciudadanos':
          this.categoryPush = undefined
          this.$emit('filterAc', false)
          this.updateCitizen()
          // this.tabs = event.target.id
          break
        case 'tab-alertas':
          this.updateAlertsVertical(this.kpisCurrentFilter)
          this.$emit('filterAc', false)
          break
      }
    },
    getKpisGeneric (list, vertical) {
      if (stationSelected) console.log('SUBTYPE SELECCIONADO => ', stationSelected.subtype)
      const component = this
      var kpisStationAux = []
      if (list) {
        // -- MOCK
        if (vertical === 'Meteorology') {
          // -- Medioambiente
          // fechas random de hoy y 7 días
          jsonKpisWatherToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisWatherSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisAirQualityToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisAirQualitySevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisAlergenosToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisAlergenosSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisNoiseLevelToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisNoiseLevelSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        } else if (vertical === 'Parking') {
          // -- Parking
          jsonKpisParkingToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisParkingSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          // -- Panel parking
          jsonKpisPanelParkingToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisPanelParkingSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          // -- Sensor zones
          jsonKpisSensorZonesToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisSensorZonesSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        } else if (vertical === 'Autobuses') {
          // -- Bus
          jsonKpisBusToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisBusSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          // -- Bus line
          jsonKpisBusLineToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisBusLineSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          // -- Bus Stop
          jsonKpisBusStopToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisBusStopSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        } else if (vertical === 'Bike') {
          // -- Bikes
          jsonKpisBikesToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisBikesSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        } else if (vertical === 'Parksandgardens') {
          jsonKpisParksInformationToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisParksInformationSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisGroundToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisGroundSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisCountersToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisCountersSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisIncidenceToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisIncidenceSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
          jsonKpisValvesToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisValvesSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        } else if (vertical === 'cruises') {
          jsonKpisCruisesToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisCruisesSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        } else if (vertical === 'CRM') {
          jsonKpisCitizenToday.forEach(element => {
            element.from = this.setTimeRandom(false)
            element.to = this.setTimeRandom(false)
          })
          jsonKpisCitizenSevenDays.forEach(element => {
            element.from = this.setTimeRandom(true)
            element.to = this.setTimeRandom(true)
          })
        }
        if (!stationSelected) {
          // Carga el json correspondiente dependiendo del filtro y la frecuencia seleccionada
          list.forEach(item => {
            if (item === 'dataSourceWeather') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisWatherToday] : [...kpisStationAux, ...jsonKpisWatherSevenDays]
            if (item === 'dataSourceAirQuality') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisAirQualityToday] : [...kpisStationAux, ...jsonKpisAirQualitySevenDays]
            if (item === 'dataSourceAeroAllergen') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisAlergenosToday] : [...kpisStationAux, ...jsonKpisAlergenosSevenDays]
            if (item === 'dataSourceNoiseLevel') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisNoiseLevelToday] : [...kpisStationAux, ...jsonKpisNoiseLevelSevenDays]

            if (item === 'dataSourceParking') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisParkingToday] : [...kpisStationAux, ...jsonKpisParkingSevenDays]
            if (item === 'dataSourcePanelParking') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisPanelParkingToday] : [...kpisStationAux, ...jsonKpisPanelParkingSevenDays]
            if (item === 'dataSourceSensorZones') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisSensorZonesToday] : [...kpisStationAux, ...jsonKpisSensorZonesSevenDays]

            if (item === 'dataSourceBusRealTime') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisBusToday] : [...kpisStationAux, ...jsonKpisBusSevenDays]
            if (item === 'dataSourceBusLine') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisBusLineToday] : [...kpisStationAux, ...jsonKpisBusLineSevenDays]
            if (item === 'dataSourceBusStop') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisBusStopToday] : [...kpisStationAux, ...jsonKpisBusStopSevenDays]

            if (item === 'dataSourceBike') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisBikesToday] : [...kpisStationAux, ...jsonKpisBikesSevenDays]

            if (item === 'dataSourceParkInformation') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisParksInformationToday] : [...kpisStationAux, ...jsonKpisParksInformationSevenDays]
            if (item === 'dataSourceGround') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisGroundToday] : [...kpisStationAux, ...jsonKpisGroundSevenDays]
            if (item === 'dataSourceCounters') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisCountersToday] : [...kpisStationAux, ...jsonKpisCountersSevenDays]
            if (item === 'dataSourceIncidence') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisIncidenceToday] : [...kpisStationAux, ...jsonKpisIncidenceSevenDays]
            if (item === 'dataSourceValves') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisValvesToday] : [...kpisStationAux, ...jsonKpisValvesSevenDays]

            if (item === 'dataSourceFleetRealTime') kpisStationAux = component.kpisCurrentFilter === '1d' ? [...kpisStationAux, ...jsonKpisCruisesToday] : [...kpisStationAux, ...jsonKpisCruisesSevenDays]
          })
        } else {
          if (stationSelected.subtype === 'weather') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisWatherToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisWatherSevenDays))
          if (stationSelected.subtype === 'airQuality') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisAirQualityToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisAirQualitySevenDays))
          if (stationSelected.subtype === 'aeroAllergen') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisAlergenosToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisAlergenosSevenDays))
          if (stationSelected.subtype === 'noiseLevel') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisNoiseLevelToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisNoiseLevelSevenDays))

          if (stationSelected.subtype === 'parking') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisParkingToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisParkingSevenDays))
          if (stationSelected.subtype === 'panelParking') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisPanelParkingToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisPanelParkingSevenDays))
          if (stationSelected.subtype === 'sensorZones') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisSensorZonesToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisSensorZonesSevenDays))

          if (stationSelected.subtype === 'busRealTime') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisBusToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisBusSevenDays))
          if (stationSelected.subtype === 'busLine') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisBusLineToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisBusLineSevenDays))
          if (stationSelected.subtype === 'busStop') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisBusStopToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisBusStopSevenDays))

          if (stationSelected.subtype === 'bike') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisBikesToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisBikesSevenDays))

          if (stationSelected.subtype === 'parkInformation') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisParksInformationToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisParksInformationSevenDays))
          if (stationSelected.subtype === 'ground') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisGroundToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisGroundSevenDays))
          if (stationSelected.subtype === 'counters') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisCountersToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisCountersSevenDays))
          if (stationSelected.subtype === 'incidence') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisIncidenceToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisIncidenceSevenDays))
          if (stationSelected.subtype === 'valves') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisValvesToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisValvesSevenDays))

          if (stationSelected.subtype === 'fleetRealTime') kpisStationAux = component.kpisCurrentFilter === '1d' ? this.mockKpisValues(_.cloneDeep(jsonKpisCruisesToday)) : this.mockKpisValues(_.cloneDeep(jsonKpisCruisesSevenDays))
        }
        component.kpisStation = kpisStationAux
        for (let i = 0; i < component.kpisStation.length; i++) {
          component.kpisStation[i].show = true
        }
        component.loadingKpis = false
      }
    },
    getAlertsToday () {
      let val = jsonAlertsCRM.today
      // const component = this
      // console.log('getAlertToday--->',val);
      var array = []
      if (val) {
        // this.dataTable = val
        this.dataTableAux = val
        for (var i = 0; i < this.dataTableAux.length; i++) {
          if (this.dataTableAux[i].clmModule === 'crm') {
            this.dataTableAux[i].severity = this.dataTableAux[i].severity.substring(2)
            array.push(this.dataTableAux[i])
          }
        }
        this.dataTableToday = array
        // this.mapFilterAlert(val, component.verticalType, 'alert', 'week')
      }
    },
    getAlertsWeek () {
      // const component = this
      // console.log('getAlertsweek--->',val);
      let val = jsonAlertsCRM.lastSevenDays
      var array = []
      if (val) {
        // this.dataTable = val
        this.dataTableAux = val
        for (var i = 0; i < this.dataTableAux.length; i++) {
          if (this.dataTableAux[i].clmModule === 'crm') {
            this.dataTableAux[i].severity = this.dataTableAux[i].severity.substring(2)
            array.push(this.dataTableAux[i])
          }
        }
        this.dataTableWeek = array
        // this.mapFilterAlert(val, component.verticalType, 'alert', 'week')
      }
    },
    rerender (callback) {
      this.$nextTick(() => {
        callback()
      })
    },
    loadCity (list, vertical) {
      // const component = this
      // let inData = null
      // let timeIntervalCity = 'interval'
      switch (vertical) {
        case 'Parksandgardens':
          this.getKpisGeneric(list, vertical)
          break
        case 'Meteorology':
          this.getKpisGeneric(list, vertical)
          break
        case 'Parking':
          this.getKpisGeneric(list, vertical)
          break
        case 'Bike':
          this.getKpisGeneric(list, vertical)
          break
        case 'Autobuses':
          this.getKpisGeneric(list, vertical)
          break
        case 'cruises':
          this.getKpisGeneric(list, vertical)
          break
        case 'CRM':
          let listTypes = []
          if (list === 'dataSourceAll') {
            listTypes.push('all')
          }
          this.getKpisGeneric(listTypes, vertical)
          break
      }
      // for (var i = 0; i < listTypes.length; i++) {
      //   if (listTypes[i] === 'panelParkingFree') {
      //     timeIntervalCity = 'current'
      //   } else {
      //     timeIntervalCity = 'interval'
      //   }
      //   inData = {
      //     product: 'city',
      //     typeProduct: 'product',
      //     type: listTypes[i],
      //     time: timeIntervalCity,
      //     interval: component.kpisCurrentFilter.replace(/\D/g, ''),
      //     intervalUnit: component.kpisCurrentFilter.replace(/[0-9]/g, '')
      //   }
      //   this.$store.dispatch('updateKpisGeneric', inData)
      // }
    },
    loadCityRoute (listSelected, tab) {
      // console.log("ciudad")
      switch (this.$route.name) {
        case 'MobilityAndTransportMain':
          this.kpisStation = []
          this.loadCity(listSelected, tab)
          break
        case 'EnvironmentDashboard':
          // Obtener lista de tipos
          // this.$emit('getDataSourceFilter')
          this.kpisStation = []
          this.loadCity(listSelected, tab)
          break
        case 'BikeDashboard':
          // Obtener lista de tipos
          // this.$emit('getDataSourceFilter')
          this.kpisStation = []
          this.loadCity(listSelected, 'bike')
          break
        case 'AutobusesDashboard':
          // Obtener lista de tipos
          // this.$emit('getDataSourceFilter')
          this.kpisStation = []
          this.loadCity(listSelected, 'bus')
          break
        case 'CruisesMain':
          // Obtener lista de tipos
          // this.$emit('getDataSourceFilter')
          this.kpisStation = []
          this.loadCity(listSelected, 'cruises')
          // console.log(this.$route.name)
          break
        case 'ParksAndGardensDashboard':
          this.kpisStation = []
          this.loadCity(listSelected, tab)
          break
        case 'CRMDashboard':
          this.kpisStation = []
          this.loadCity(listSelected, tab)
          break
      }
    },
    checkEntitySelectedLoadCity (listSelected) {
      var listSelectedAux = []
      for (let i = 0; i < listSelected.length; i++) {
        listSelectedAux.push(listSelected[i].toLowerCase())
      }
      // console.log(listSelectedAux)
      // console.log(stationSelected.subtype2)
      var a = listSelectedAux.indexOf('datasource' + stationSelected.subtype2.toLowerCase())
      // console.log(a)
      if (a === -1) {
        // console.log('no  esta')
        // this.updateSelectedStation()
        document.getElementById('dataIframe').contentWindow.resetEntityCards()
        stationSelected = null
        this.selectedItems = 0
        // this.updateSelectedStation()
        // this.loadCityRoute(listSelected)
      }
    },
    // primer parametro: lista seleccionada de dataSource
    // segundo parametro: Pestaña seleccionados
    updateKpis (listSelected, tab) {
      const component = this
      component.kpisStation = []
      component.zoomChartKpiData = -1
      var inData = null
      // En este "if" añadiremos a loos verticales que no tienen el filtro de dtaSources (toolsGeneric)
      if (tab !== 'CruisesRealTime') {
        listSelected = component.$parent.$parent.$refs.toolsGeneric.getCaterogySelected()
      } else {
        listSelected = component.$parent.$parent.getFilterCategorySelected()
      }
      component.loadingKpis = true
      if (this.$refs.kpiVertical) {
        this.$refs.kpiVertical.kpiFilterSelected = ['all']
      }
      if (stationSelected && stationSelected.subtype !== 'alert') {
        this.checkEntitySelectedLoadCity(listSelected)
      }
      // Cambiar funcionalidad de entrar de la estacion cuando se sincronice con GIS
      if (stationSelected) {
        this.kpiTagType = stationSelected.subtype2
        this.titleStation = stationSelected.name
        this.selectedItems = stationSelected.selected
        this.iconSelected = stationSelected.iconIsolated
        this.chartHide = false
        component.titleKpiSelected = ''
        inData = {
          product: stationSelected.id,
          typeProduct: stationSelected.typeProduct,
          type: stationSelected.subtype,
          time: 'interval',
          interval: component.kpisCurrentFilter.replace(/\D/g, ''),
          intervalUnit: component.kpisCurrentFilter.replace(/[0-9]/g, '')
        }
        if (stationSelected.subtype === 'alert') {
          this.titleStation = 'Detalle de la alerta'
          this.kpiAlert = true
          this.kpiAlertContent.name = stationSelected.name
          this.kpiAlertContent.subtype = stationSelected.subtype2
          this.kpiAlertContent.description = stationSelected.description.toString()
          this.kpiAlertContent.date = this.formatLocaleDate(stationSelected.date) + ' - ' + this.formatLocaleHour(stationSelected.date)
          this.chartHide = true
        } else if (stationSelected.subtype === 'incidence') {
          this.titleStation = 'Detalle de la incidencia'
          this.kpiAlert = true
          this.kpiAlertContent.name = stationSelected.name
          this.kpiAlertContent.subtype = stationSelected.subtype2
          if (stationSelected.description) {
            this.kpiAlertContent.description = stationSelected.description.toString()
          }
          this.kpiAlertContent.date = ''
          this.chartHide = true
        } else if (stationSelected.subtype === 'sensorZones') {
          // this.iconSelected = 'ods-icon-icon_parking_zone_isolated'
          inData.product = stationSelected.multiPolygonIdse
        } else if (stationSelected.subtype === 'parkingPanel') {
          // this.titleStation = ''
          // inData.product = 'Panel_11'
          this.chartHide = true
          // inData.type = 'panelParkingFree'
          inData.type = 'panelParking'
          // inData.time = 'current'
          // this.kpisStation.entityType = 'panelParking'
        } else if (stationSelected.subtype === 'fleetRealTime') {
          // this.iconSelected = 'ods-icon-icon_parking_zone_isolated'
          inData.type = 'fleet'
          // this.titleStation = categoria[stationSelected.properties.id - 1]
          // this.typeVehicule = stationSelected.properties
          this.iconSelected = 'ods-icon-icon_floats_isolated'
        } else {
          this.kpiAlert = false
        }
        // -- this.$store.dispatch('updateKpisGeneric', inData)
        this.loadCityRoute(listSelected, tab)
      } else {
        // if (stationSelected.subtype === 'parkingPanel') {
        //   this.chartHide = true
        // }
        this.titleStation = 'city'
        this.typeVehicule = ''
        this.kpiAlert = false
        this.chartHide = false
        this.iconSelected = 'ods-icon-icon_city_isolated'
        this.loadCityRoute(listSelected, tab)
      }
      if (listSelected.length === 1 && listSelected.indexOf('dataSourcePanelParking') === 0) {
        this.onlyParkingPanel = true
        this.chartHide = true
      } else {
        this.onlyParkingPanel = false
      }
    },
    filterIntervalKpisChange () {
      const component = this
      component.$emit('updateKpiGeneric')
      if (this.verticalType === 'CRM') {
        this.updateAlertsVertical()
        if (this.tabs === 'ciudadanos') {
          this.updateCitizen()
        } else if (this.tabs === 'tramites') {
          this.updateKpisCRM()
        }
      }
    },

    // Carga de datos mockeados para las gráficas
    loadStationByIdChartData () {
      const component = this
      let kpiChartData = []
      if (this.$route.name === 'EnvironmentDashboard') {
        // -- Medioambiente
        this.mockChartData(jsonWeatherChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonAirQualityChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonWeatherChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonAirQualityChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonAlergenosChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonNoiseLevelChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonNoiseLevelChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonAlergenosChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)

        if (component.kpiSelected.entityType === 'Weather') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonWeatherChartDataToday] : [...kpiChartData, ...jsonWeatherChartDataSevenDays]
        if (component.kpiSelected.entityType === 'AirQuality') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonAirQualityChartDataToday] : [...kpiChartData, ...jsonAirQualityChartDataSevenDays]
        if (component.kpiSelected.entityType === 'AeroAllergen') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonAlergenosChartDataToday] : [...kpiChartData, ...jsonAlergenosChartDataSevenDays]
        if (component.kpiSelected.entityType === 'NoiseLevel') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonNoiseLevelChartDataToday] : [...kpiChartData, ...jsonNoiseLevelChartDataSevenDays]
      } else if (this.$route.name === 'MobilityAndTransportMain') {
        // -- Movilidad
        this.mockChartData(jsonParkingChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonParkingChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonPanelParkingChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonPanelParkingChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonSensorZonesChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonSensorZonesChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)

        this.mockChartData(jsonBusChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonBusChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonBusLineChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonBusLineChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonBusStopChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonBusStopChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)

        this.mockChartData(jsonBikesChartDataToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonBikesChartDataSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)

        if (component.kpiSelected.entityType === 'parking') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonParkingChartDataToday] : [...kpiChartData, ...jsonParkingChartDataSevenDays]
        if (component.kpiSelected.entityType === 'panelParking') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonPanelParkingChartDataToday] : [...kpiChartData, ...jsonPanelParkingChartDataSevenDays]
        if (component.kpiSelected.entityType === 'sensorZones') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonSensorZonesChartDataToday] : [...kpiChartData, ...jsonSensorZonesChartDataSevenDays]
        if (component.kpiSelected.entityType === 'bus') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonBusChartDataToday] : [...kpiChartData, ...jsonBusChartDataSevenDays]
        if (component.kpiSelected.entityType === 'busLine') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonBusLineChartDataToday] : [...kpiChartData, ...jsonBusLineChartDataSevenDays]
        if (component.kpiSelected.entityType === 'busStop') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonBusStopChartDataToday] : [...kpiChartData, ...jsonBusStopChartDataSevenDays]
        if (component.kpiSelected.entityType === 'bike') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonBikesChartDataToday] : [...kpiChartData, ...jsonBikesChartDataSevenDays]
      } else if (this.$route.name === 'ParksAndGardensDashboard') {
        this.mockChartData(jsonChartParksInformationToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartParksInformationSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartInicidenceToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartInicidenceSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartCountersToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartCountersSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartValvesToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartValvesSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartGroundToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartGroundSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        if (component.kpiSelected.entityType === 'parkInformation') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartParksInformationToday] : [...kpiChartData, ...jsonChartParksInformationSevenDays]
        if (component.kpiSelected.entityType === 'Incidence') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartInicidenceToday] : [...kpiChartData, ...jsonChartInicidenceSevenDays]
        if (component.kpiSelected.entityType === 'Counters') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartCountersToday] : [...kpiChartData, ...jsonChartCountersSevenDays]
        if (component.kpiSelected.entityType === 'SolenoidValves') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartValvesToday] : [...kpiChartData, ...jsonChartValvesSevenDays]
        if (component.kpiSelected.entityType === 'Ground') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartGroundToday] : [...kpiChartData, ...jsonChartGroundSevenDays]
      } else if (this.$route.name === 'CruisesMain') {
        this.mockChartData(jsonChartCruisesToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartCruisesSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        if (component.kpiSelected.entityType === 'fleet') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartCruisesToday] : [...kpiChartData, ...jsonChartCruisesSevenDays]
      } else if (this.$route.name === 'CRMDashboard') {
        this.mockChartData(jsonChartCitizenToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartCitizenSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartSolicitationsToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartSolicitationsSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartComplaintsToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartComplaintsSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartConsultationsToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartConsultationsSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartDamageToday, false, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        this.mockChartData(jsonChartDamageSevenDays, true, component.kpiSelected.kpiMaxValue, component.kpiSelected.kpiMinValue)
        if (component.kpiSelected.entityType === 'citizens') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartCitizenToday] : [...kpiChartData, ...jsonChartCitizenSevenDays]
        if (component.kpiSelected.entityType === 'solicitations') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartSolicitationsToday] : [...kpiChartData, ...jsonChartSolicitationsSevenDays]
        if (component.kpiSelected.entityType === 'complaints') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartComplaintsToday] : [...kpiChartData, ...jsonChartComplaintsSevenDays]
        if (component.kpiSelected.entityType === 'consultations') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartConsultationsToday] : [...kpiChartData, ...jsonChartConsultationsSevenDays]
        if (component.kpiSelected.entityType === 'damage') kpiChartData = component.kpisCurrentFilter === '1d' ? [...kpiChartData, ...jsonChartDamageToday] : [...kpiChartData, ...jsonChartDamageSevenDays]
      }
      component.datosLoader = true
      if (kpiChartData.length !== 0) {
        component.chartsData = kpiChartData
        component.updateChartData(component.kpiSlideSelected)
      } else {
        component.datosChart = null
      }
    },
    updateKpiChart () {
      const component = this
      component.unitChart = component.$t(component.kpiSelected.kpiUnit)
      // - Original
      // if (stationSelected && component.kpiSelected) {
      //   component.zoomChartKpiData = undefined
      //   let inData = {
      //     // Cambiar cuando back devuelva correcto el chartType
      //     chartType: stationSelected.subtype ? stationSelected.subtype.toUpperCase() : 'PARKING',
      //     // chartType: 'PARKING',
      //     timeInterval: component.mapChartIntervalIntro(component.kpisCurrentFilter),
      //     stationId: stationSelected.id
      //   }
      //   if (inData.chartType === 'CRUISES') {
      //     inData.chartType = 'PARKING'
      //   }
      //   // this.$store.dispatch('updateStationByIdChartData', inData)
      //   this.loadStationByIdChartData()
      // } else {
      //   component.zoomChartKpiData = undefined
      //   var type = component.kpiSelected.entityType
      //   var typeFix = type.replace('Observed', '')
      //   let inData = {
      //     // Cambiar cuando back devuelva correcto el chartType
      //     chartType: typeFix ? typeFix.toUpperCase() : 'PARKING',
      //     // chartType: 'PARKING',
      //     timeInterval: component.mapChartIntervalIntro(component.kpisCurrentFilter),
      //     stationId: 'city'
      //   }
      //   if (inData.chartType === 'CRUISES') {
      //     inData.chartType = 'PARKING'
      //   }
      // this.$store.dispatch('updateStationByIdChartData', inData)
      // }

      // -- Mockeado
      component.zoomChartKpiData = undefined
      var type = component.kpiSelected.entityType
      var typeFix = type.replace('Observed', '')
      let inData = {
        // Cambiar cuando back devuelva correcto el chartType
        chartType: typeFix ? typeFix.toUpperCase() : 'PARKING',
        // chartType: 'PARKING',
        timeInterval: component.mapChartIntervalIntro(component.kpisCurrentFilter),
        stationId: 'city'
      }
      if (inData.chartType === 'CRUISES') {
        inData.chartType = 'PARKING'
      }
      this.loadStationByIdChartData()
    },
    updateChartData () {
      const component = this
      // -- Original
      // if (stationSelected && component.kpiSelected) {
      //   component.datosChart = component.mapListChartKpi(
      //     component.chartsData,
      //     stationSelected.id,
      //     component.kpisCurrentFilter,
      //     component.kpiSelected.measureType,
      //     component.kpiSelected.entityType
      //   )
      // } else {
      //   component.datosChart = component.mapListChartKpi(
      //     component.chartsData,
      //     'city',
      //     component.kpisCurrentFilter,
      //     component.kpiSelected.measureType,
      //     component.kpiSelected.entityType
      //   )
      // }

      // -- Mockeado
      component.datosChart = component.mapListChartKpi(
        component.chartsData,
        'city',
        component.kpisCurrentFilter,
        component.kpiSelected.measureType,
        component.kpiSelected.entityType
      )
    },
    showZoomChart () {
      const component = this
      component.chartModal = true
    },
    showChartBykpi (data) {
      const component = this
      component.datosLoader = false
      component.titleChartModal = data.measureType ? data.measureType : 'tipo'
      component.unitChartModal = data.kpiUnit ? data.kpiUnit : 'unidad'
      component.chartModal = true
      component.kpiSelected = data
      console.log('al click-_---------------------->', data)
      // Cambiar cuando haya datos
      // var type = data.entityType
      // var type = 'PARKING'
      component.datosChart = null
      component.updateKpiChart()
      // ACTIVAMOS EL MODAL
      component.showZoomChart()
    },
    showDialogAlert () {
      const component = this
      if (component.verticalType === 'cruises') {
        component.verticalType = 'fleet'
      }
      switch (component.verticalType) {
        case 'meteo':
          component.updateAlerts('environment', 'alert', jsonAlertsMeteorologia)
          break
        case 'mobility':
          component.updateAlerts('mobility', 'alert', jsonAlertsMobility)
          break
        case 'Parksandgardens':
          component.updateAlerts('parksandgardens', 'alert', jsonAlertsParksandgardens)
          break
        case 'fleet':
          component.updateAlerts('fleet', 'alert', jsonAlertsCruises)
          break
      }
      this.$refs.modalGenericAlerts.changeState()
    },
    showDialogCampaign () {
      const component = this
      if (component.verticalType === 'cruises') {
        component.verticalType = 'fleet'
      }
      switch (component.verticalType) {
        case 'meteo':
          component.updateCampaigns('environment', 'campaign', jsonCampaingsMeteorologia)
          break
        case 'mobility':
          component.updateCampaigns('mobility', 'campaign', jsonCampaingsMobility)
          break
        case 'Parksandgardens':
          component.updateCampaigns('parksandgardens', 'campaign', jsonCampaingsParksandgardens)
          break
        case 'fleet':
          component.updateCampaigns('fleet', 'campaign', jsonCampaingsCruises)
          break
      }
      this.$refs.modalGenericCampaigns.changeState()
    },
    async getSelectedStation (val) {
      const component = this
      stationSelected = val
      // console.log('stationSelected AL click------------->', stationSelected)
      // component.updateKpis()
      this.updateKpis(null, this.$parent.$parent.tabsVertical)
      component.$emit('setPopupParking', true, stationSelected, stationSelected.subtype, this.currentKpi)
    },
    async getSelectedStationBackup (val) {
      const component = this
      stationSelected = val
      let inData = {}
      // console.log('stationSelected AL click------------->', stationSelected)
      // component.updateKpis()
      if (stationSelected.subtype === 'noiseLevel' || stationSelected.subtype === 'aeroAllergen' || stationSelected.subtype === 'weather' || stationSelected.subtype === 'airQuality' || stationSelected.subtype === 'parking' || stationSelected.subtype === 'panelParking' || stationSelected.subtype === 'sensorZones' || stationSelected.subtype === 'bike' || stationSelected.subtype === 'busRealTime' || stationSelected.subtype === 'busLine' || stationSelected.subtype === 'busStop' || stationSelected.subtype === 'aeroAllergen' || stationSelected.subtype === 'weather' || stationSelected.subtype === 'airQuality' || stationSelected.subtype === 'noiseLevel') {
        inData.product = stationSelected.id
        inData.type = stationSelected.subtype
        inData.city = 'ES LPA'
        // await this.$store.dispatch('updateCurrentKpis', inData)
        this.updateKpis(null, this.$parent.$parent.tabsVertical)
        if (stationSelected.subtype === 'panelParking' || stationSelected.subtype === 'parking' || stationSelected.subtype === 'bike' || stationSelected.subtype === 'busRealTime' || stationSelected.subtype === 'busLine' || stationSelected.subtype === 'busStop') {
          component.$emit('setPopupParking', true, stationSelected, stationSelected.subtype, this.currentKpi)
        }
      } else {
        if (stationSelected.subtype !== 'fleetRealTime') {
          component.$emit('setPopupVehicle', false)
        } else {
          // console.log('click de los coches------------------------__>', stationSelected.properties.id);
          this.updateKpis(this.$parent.$parent.listCruises[this.$parent.$parent.tabsVertical].listCategorySelected, this.$parent.$parent.tabsVertical)
          component.$emit('setPopupVehicle', true, stationSelected)
        }
      }
    },
    updateSelectedStation (tab) {
      stationSelected = null
      this.selectedItems = 0
      this.updateKpis(undefined, tab)
      // console.log('llamada click en mapa----------------------------->');
    },
    setCarouselOptions (event) {
      const component = this
      component.windowWidth = document.documentElement.clientWidth
      if (component.buttonsLength >= 3 && component.windowWidth <= 1250) {
        component.carouselButtons = true
      } else {
        component.carouselButtons = false
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setCarouselOptions)
  },
  components: {
    Card,
    InfoMsg,
    StatusCero,
    AlertsAndCampaignList,
    AlertsAndCampaignListCrm,
    ModalGeneric,
    KpiVertical,
    ChartModal
  },
  mounted () {
    const component = this
    // component.$nextTick(function () {
    //   component.buttonsLength = component.$refs.buttons.childElementCount
    //   window.addEventListener('resize', component.setCarouselOptions)
    //   component.setCarouselOptions()
    // })
    window.document.addEventListener('setPopupBus', setPopupBus, false)
    function setPopupBus (e) {
      component.$emit('setPopupBus', e.detail)
    }
    window.document.addEventListener('setPopupBusLine', setPopupBusLine, false)
    function setPopupBusLine (e) {
      component.$emit('setPopupBusLine', e.detail)
    }
    if (this.verticalType === 'CRM') {
      this.getAlertsToday()
      this.getAlertsWeek()
      this.updateAlertsVertical()
    }
  }
}
</script>

<style lang="scss" scoped>

  .verticalGeneric{
    #pane-tramites{
      background: $--color-primary-light-9;
      height: calc(100vh - 60px);
    }
    #pane-ciudadanos{
      background: $--color-primary-light-9;
      height: calc(100vh - 60px);
    }
    #pane-alertas{
      padding: rem(10) rem(30);
      background: white;
    }
    &.map-panel {
      box-shadow: none;
      /* height: calc(100vh - 72px); */
      padding: 0;
    }
    /deep/ .heightMax{
      .status-cero{
        background: #FFF;
      }
    }
    /deep/ .ods-tabs {
      display: block;
      &__header{
        box-shadow: 0px 9px 15px -3px rgba(229, 229, 229, 0.55)
      }
    }
    .alertsTab__Crm{
      background: white;
      /deep/ .ods-scrollbar{
        height: calc(100vh - 214px);
        /* height: 100%; */
        overflow-y: none;
        overflow: hidden;
        &__wrap{
          /* overflow: scroll; */
          scrollbar-width: none;
          .ods-scrollbar__view{
          }
          .ods-table__row{
            cursor: pointer;
          }
        }
      }
    }
    &.map-panel {
      box-shadow: none;
      height: calc(100vh - 72px);
      padding: 0;
    }

    /deep/ .VueCarousel{
      &-wrapper{
        margin: 0 auto;
        width: 90%;
      }
      &-slide {
        flex-basis: auto !important;
        padding-right: rem(12);
      }
      &-navigation-prev{
        left: rem(12);
      }
      &-navigation-next{
        right: rem(12);
      }
    }

    .panel-dashboard__content{
      display: flex;
      align-items: center;
    }
    .sc-dashboard__kpis__content{
      // display: flex;
      height: 100%;
    }
    /deep/ .ods-scrollbar{
        height: 100%;
        &__wrap{
          height: 101%;
        }
    }
    /deep/ .sc-card__header__inner{
      border-bottom: 0;
    }
    /deep/ .sc-dashboard__kpis{
      .sc-card__body {
        height: calc(100vh - 150px);
        padding-top: 0;
      }
      .sc-card__body-inner{
        padding: 0;
        height: 100%;
        background: $--color-primary-light-9;
      }
      .sc-card__header{
        background: $--color-white;
      }
    }
    .sc-panel__header {
      padding: rem(16) rem(32) rem(8) rem(32);
      background: $--color-white;
    }
    .sc-dashboard__row{
      height: 100%;
    }
    .sc-card {
      box-shadow: none;
      &.card-collapsed {
        -webkit-transition: top 0.5s; /* For Safari 3.1 to 6.0 */
        border-radius: 0;
        border-top: 1px solid $--color-grey-light;
        height: auto;
        position: absolute;
        top: calc(100vh - 188px);
        transition: top 0.5s;
        width: 100%;
        z-index: 5;
        &.actived {
          top: calc(100vh - 508px);
        }
        .card-title {
          align-items: center;
          display: flex;
          justify-content: center;
          justify-items: center;
          i {
            color: $--color-blue-dark;
            cursor: pointer;
            font-size: rem(32);
            margin-right: rem(16);
          }
          span {
            font-size: rem(12);
            text-transform: uppercase;
          }
        }
      }
      .titleStation {
        vertical-align: middle;
        display: inline-block;
        width: calc(100% - 28px) !important;
      }
    }
    /deep/ .ods-kpi__list {
      height: rem(100);
    }
    /deep/ .sc-card__row {
      margin: 0;
    }
    /deep/ .sc-card__body {
    padding: 0;
    }
    &__wrapper-all {
      width: 100%; // cambiar a 90% en pantallas grande en un futuro...
      height: 95%;
    }
    &__chart{
      &__size{
        width: rem(500);
      }
      &__zero{
        display: flex;
        height: rem(320);
      }
      &__top{
        position: relative;
        padding-left: rem(32);
        padding-top: rem(16);
        padding-bottom: 20px;
        z-index: 4;
        .expandChart {
          position: absolute;
          top: rem(16);
          right: rem(32);
          padding: rem(8);
          z-index: 4;
          i {
            margin: 0;
          }
        }
      }
      &__title{
        @extend %font-title-chart;
      }
      &__zoom {
        justify-content: flex-end;
        display: flex;
        .ods-button {
          margin: 0;
          padding: 0;
          width: rem(40);
          height: rem(36);
          padding-top: rem(4);
          background-color: $--color-white;
          box-shadow: none;
          border-radius: rem(2);
          border: 0;
          cursor: pointer;
          &:hover {
            background: $--color-blue-dark;
            color: $--color-white;
          }
          &:focus, &:active {
            background: $--color-white;
            color: $--color-blue-dark;
          }
          i {
            margin-left:0;
          }
        }
      }
    }
  }
  /deep/ .ods-dialog.sc-modal {
    max-width: rem(720);
    .ods-dialog__body{
      padding: 0;
      margin-top: 0;
    }
    .sc-modal__body{
      align-items: center;
      background-color: $--color-white;
      display: flex;
      justify-content: center;
      margin-top: 0;
      padding: 0;
      width: 100%;
      .ods-row{
        width: 100%;
      }
    }
    .sc-card__body-inner{
      display: flex;
      // height: rem(340);
      padding: 0;
    }
    /deep/ .ods-scrollbar__wrap{
      height: calc(100% - -17px);
      max-height: inherit;
      .ods-scrollbar__view{
        height: 100%;
      }
    }
  }
  .unitChart {
    margin-left: rem(8);
  }
  /deep/ .chartKpiData{
    padding: 0 !important;
    .sc-modal{
      &__body{
        padding: 0;
      }
    }
  }
  /deep/ .zChartKpiModal{
    &.ods-dialog{
      &.sc-modal{
        max-width: 60%;
      }
    }
    .card-title{
      text-transform: uppercase;
    }
  }
  /deep/ .ct-chart .ct-point {
    fill: $--color-secondary;
    r: 3;
  }
  /deep/ .ods-kpi--no-href {
    display: flex;
    height: 100%;
    &.umbral{
      ul{
        color: $--color-red;
      }
    }
    .ods-kpi {
      &__list {
        height: auto;
        min-height: rem(64);
        width: 100%;
      }
      &__number {
        &+.kpi_title{
          margin-top: rem(8);
        }
      }
    }
    .kpi_circle{
      height: auto;
      line-height: rem(16);
      margin-bottom: rem(8);
      & > span {
        &:first-child{
          margin-right: 3px;
        }
        display: inline-block;
        line-height: 1;
        word-break: break-word;
        margin: 0;
      }
    }
  }
  .maxSizeKpi {
    padding: rem(16);
  }
  .maxSizeKpiAlert {
    // max-height: calc(100vh - 236px);
    padding: rem(16);
    // width: 100%;
  }
  .alertDialog .ods-tabs__content .ods-tab-pane {
    margin-top: rem(35);
  }
  /deep/ .chart-container {
    .sc-card__body-inner{
      padding: 0;
    }
    .card-title {
      line-height: rem(16);
      padding-right: rem(16);
    }
  }
  /deep/ .ods-table .cell, .ods-table th div {
    padding-left: 0;
  }
  /deep/ .ct-chart .ct-chart-line .ct-label.ct-horizontal.ct-end {
    transform: rotate(-21deg) translateY(-44%) translateX(-38%);
    width: 45px !important;
  }

  /deep/ .verticalGeneric__wrapper-all .ods-scrollbar__bar.is-horizontal {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/views/VerticalGeneric.vue